export const ActionStatusTypes = {
  SUCCESS: "success",
  FAILURE: "failure",
  INDIFFERENT: "indifferent"
};

export const ActionGroupTypes = {
  ADD: "add",
  UPDATE: "update",
  DELETE: "delete",
  REVERT: "revert"
}